import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import InputGroupWrapper from './InputGroupWrapper';

const messages = defineMessages({
  Clear: 'Clear',
});

/*
Add clear button after select control
Use the show property to toggle button visibility
 */
const ClearButtonWrapper = ({ children, show, onClear, intl }) => (
  <InputGroupWrapper
    rightClassName="input-group-btn"
    right={
      !show ? null : (
        <button
          type="button"
          className="btn btn-default"
          onClick={onClear}
          title={intl.formatMessage(messages.Clear)}
        >
          <span className="fa fa-times" />
        </button>
      )
    }
  >
    {children}
  </InputGroupWrapper>
);
ClearButtonWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};
export default injectIntl(ClearButtonWrapper);
